import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import { invalidateSolarPriceDependents } from "./solar-price-dependents"
import type {
  SolarProposalRebatesDto,
  UpdateSolarProposalRebatesDto,
} from "../dto/solar-proposal-pricing-steps.dto"
import { solarProposalService } from "../services/solar-proposal.service"

/** Saves the rebates; like an adder change, it leaves pricing out of date. */
export default function useUpdateSolarProposalRebates(): UseMutationResult<
  SolarProposalRebatesDto,
  unknown,
  { proposalId: string; body: UpdateSolarProposalRebatesDto }
> {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ proposalId, body }) =>
      solarProposalService.putRebates(proposalId, body),
    onSuccess: (rebates, { proposalId }) => {
      queryClient.setQueryData(
        queryKeys.solarProposal.rebates(proposalId),
        rebates,
      )
      invalidateSolarPriceDependents(queryClient, proposalId, {
        except: [`header`, `savings`],
      })
    },
  })
}
